<template>
	<div class="overlay">
		<div style="background: white; width: 600px; box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12); border-radius: 4px; height: 200px;">
			<div style="color: #38404f;display: flex; align-items: center; justify-content: center; padding-top: 25px; padding-bottom: 10px; font-weight: bold;">
				Session Expired
			</div>
			<hr>
			<div style="text-align: center; padding-top: 20px;">
				<p>You have left this browser idle for 10 minutes.</p>
				<p>You have {{ second }} seconds left</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				time: 30000
			}
		},
		computed: {
			second() {
				return this.time / 1000
			}
		},
		created() {
			let timerId = setInterval(() => {
				this.time -= 1000;
				if (!this.$store.state.idleVue.isIdle) {
					clearInterval(timerId)
				}

				if (this.time < 1) {
					clearInterval(timerId)
					localStorage.removeItem('userData')
					location.reload()
				}
			}, 1000)
		}
	}
</script>

<style lang="postcss" scoped>
	.overlay {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 100;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal {
		width: 500px;
		box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
		border-radius: 4px;
		background: white;
	}

	.modal__title {
		color: #38404f;
		@apply flex items-center justify-between p-3 font-bold;
	}
</style>